export default __webpack_public_path__ + "static/Merito-a53ffdd89640549c357cf3d1ba3dcdf1.png";